module.exports = __webpack_public_path__ + "static/media/cq_grassetto b.cda315bf.svg";